import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useEffect, useState } from 'react';
import { getReturnableNodes } from '@/services';
/**
 * 退回弹窗内容（含拉接口 + 节点选择）：
 *   - mount 时拉 getReturnableNodes(instanceId)
 *   - 默认选中列表最后一个节点（最近的审批节点）
 *   - 用户点弹窗确认时把当前选中的 nodeId 通过 onConfirm 抛给上层
 *
 * 上层 FlowCenterModal 用法：
 *   handleAction({
 *     title: '确认退回',
 *     content: <ReturnSelect instanceId={...} onConfirm={setReturnToNodeId} />,
 *     onOk: () => handleApproveSubmit('return'),
 *   });
 */
function ReturnSelect({
  instanceId,
  onConfirm
}) {
  const [nodes, setNodes] = useState([]);
  const [value, setValue] = useState('');
  useEffect(() => {
    let cancelled = false;
    if (!instanceId) return;
    getReturnableNodes(instanceId).then(list => {
      if (cancelled) return;
      setNodes(list);
      // 默认选中最近节点
      setValue(list[list.length - 1]?.id || '');
    });
    return () => {
      cancelled = true;
    };
  }, [instanceId]);
  const handleChange = v => {
    console.log('v', v);
    setValue(v);
  };
  const handleConfirm = () => {
    onConfirm(value);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 12
    }
  }, "\u786E\u5B9A\u8981\u9000\u56DE\u8BE5\u7533\u8BF7\u5417\uFF1F"), /*#__PURE__*/React.createElement(_Select, {
    value: value,
    onChange: handleChange,
    style: {
      width: '100%'
    },
    placeholder: "\u8BF7\u9009\u62E9\u9000\u56DE\u5230",
    options: nodes.map(node => ({
      label: node.name,
      value: node.id
    }))
  }), /*#__PURE__*/React.createElement(ConfirmBridge, {
    onConfirm: handleConfirm
  }));
}

/**
 * 桥接组件：openConfirm 的 onOk 在父组件闭包中，ReturnSelect 自身拿不到。
 * 用 ref 模式把"用户当前选中的 nodeId"和"确认回调"挂到 window 临时变量
 * 上，外层 onOk 同步调用 returnSelectConfirm() 拿到最新的 onConfirm 触发。
 *
 * 简化方案：直接用 React Context，但 openConfirm 渲染 confirm 不在 React 树里，
 * 用 module-level ref 最简单。这里用模块作用域的临时 ref。
 */
let _pendingConfirm = null;
export function returnSelectConfirm() {
  if (_pendingConfirm) {
    _pendingConfirm();
    _pendingConfirm = null;
  }
}
function ConfirmBridge({
  onConfirm
}) {
  useEffect(() => {
    _pendingConfirm = onConfirm;
    return () => {
      if (_pendingConfirm === onConfirm) _pendingConfirm = null;
    };
  }, [onConfirm]);
  return null;
}
export { ReturnSelect };